module.exports = __webpack_public_path__ + "img/youshi-2.09814fe2.webp";